import {
  PaginationFiltersAppliedModel,
  PaginationFiltersAppliedPayload,
  PaginationFiltersCapabilityModel,
  PaginationFiltersCapabilityPayload,
  PaginationFiltersModel,
  PaginationFiltersPayload,
  PaginationLinkModel,
  PaginationLinkPayload,
  PaginationMetaModel,
  PaginationMetaPayload,
  ParamsResponseModel,
  ParamsResponsePayload,
  SearchParamPayloadTypes,
  SearchParamTypes,
  UrlParam,
} from '../models';

export const searchParamsModelStringToSearchParamsPayloadString = (url: string): string => {
  let params: URLSearchParams;
  try {
    const parsedUrl = new URL(url);
    params = new URLSearchParams(parsedUrl.search);
  } catch {
    params = new URLSearchParams(url);
  }

  const queryParts = Object.entries(SearchParamTypes).map(([modelKey, modelValue]) => {
    const paramValue: UrlParam = params.get(modelValue);

    if (!paramValue) return '';

    const searchPayloadKey = `${modelKey}_PAYLOAD`;
    const searchParamPayloadKey = SearchParamPayloadTypes[searchPayloadKey as unknown as keyof typeof SearchParamPayloadTypes];
    return `${searchParamPayloadKey}=${paramValue}`;
  });

  return queryParts.filter(Boolean).join('&');
};

export const searchParamsPayloadStringToSearchParamsModelString = (url: string): string => {
  let params: URLSearchParams;

  try {
    const parsedUrl = new URL(url);
    params = new URLSearchParams(parsedUrl.search);
  } catch {
    params = new URLSearchParams(url);
  }

  const queryParts = Object.entries(SearchParamPayloadTypes).map(([payloadKey, payloadValue]) => {
    const paramValue: UrlParam = params.get(payloadValue);

    if (!paramValue) return '';

    const searchKey = payloadKey.replace('_PAYLOAD', '');
    const searchParamKey = SearchParamTypes[searchKey as unknown as keyof typeof SearchParamTypes];
    return `${searchParamKey}=${paramValue}`;
  });

  return queryParts.filter(Boolean).join('&');
};

export const paginationLinkPayloadToModel = (payload: PaginationLinkPayload): PaginationLinkModel => {
  const { last, next, prev, self, first } = payload;

  return {
    last: `?${searchParamsPayloadStringToSearchParamsModelString(last)}`,
    next: `?${searchParamsPayloadStringToSearchParamsModelString(next)}`,
    prev: `?${searchParamsPayloadStringToSearchParamsModelString(prev)}`,
    self: `?${searchParamsPayloadStringToSearchParamsModelString(self)}`,
    first: `?${searchParamsPayloadStringToSearchParamsModelString(first)}`,
  };
};

export const paginationMetaPayloadToModel = (payload: PaginationMetaPayload): PaginationMetaModel => {
  const { total_pages, page_size, results, all_results } = payload;

  return {
    totalPages: total_pages,
    results,
    allResults: all_results,
    pageSize: page_size,
  };
};

const paginationFiltersAppliedToModel = (payload: PaginationFiltersAppliedPayload): PaginationFiltersAppliedModel => {
  const { arguments: applied_arguments, field, type } = payload;

  return {
    arguments: applied_arguments,
    field,
    type,
  };
};

const paginationFiltersCapabilityToModel = (payload: PaginationFiltersCapabilityPayload): PaginationFiltersCapabilityModel => {
  return { ...payload };
};

export const paginationFiltersPayloadToModel = (payload: PaginationFiltersPayload): PaginationFiltersModel => {
  const { applied, capability } = payload;

  return {
    applied: paginationFiltersAppliedToModel(applied),
    capability: paginationFiltersCapabilityToModel(capability),
  };
};

export const paramsResponsePayloadToModel = (payload: ParamsResponsePayload): ParamsResponseModel => {
  const { meta, links, filters } = payload;

  return {
    links: links ? paginationLinkPayloadToModel(links) : null,
    meta: meta ? paginationMetaPayloadToModel(meta) : null,
    filters: filters ? paginationFiltersPayloadToModel(filters) : null,
  };
};
